<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-col>
										<v-card-title class="pa-2">{{ $t('titles.brevetInformations') }}</v-card-title>
									</v-col>
									<v-col class="d-flex justify-end">
										<v-btn
											v-if="inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="ml-2 mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row wrap>
									<v-col cols="12">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="brevet.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												v-model="brevet.date"
												:errorBorder="!brevetValidation.date"
												:date-label="'* ' + $t('fields.date')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="brevet.candidate_id"
												:ajax="true"
												:data="'candidates'"
												:errorBorder="!brevetValidation.candidate_id"
												:label="'* ' + $t('fields.candidate')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="brevet.course_id"
												:ajax="true"
												:data="'courses'"
												:errorBorder="!brevetValidation.course_id"
												:label="'* ' + $t('fields.course')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="brevet.price"
												:precision="2"
												:errorBorder="!brevetValidation.price"
												:label="'*' + $t('fields.price')"
											></NumberField>
										</v-col>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import DatePicker from '../../trinkets/DatePicker';
import Dropdown from '../../trinkets/Dropdown';
import Brevet from '../../../models/Brevet';
import NumberField from '../../trinkets/NumberField';

export default {
	name: 'Brevet',
	components: { InputField, NumberField, Dropdown, DatePicker },
	data: function () {
		return {
			brevet: new Brevet({ id: this.$route.params.id }),
			brevetValidation: new Brevet({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'brevet',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.brevet.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.brevet.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;

			if (this.brevet.date == null) {
				success = false;
				this.brevetValidation.date = false;
			} else {
				this.brevetValidation.date = true;
			}

			if (this.brevet.candidate_id == null) {
				success = false;
				this.brevetValidation.candidate_id = false;
			} else {
				this.brevetValidation.candidate_id = true;
			}

			if (this.brevet.course_id == null) {
				success = false;
				this.brevetValidation.course_id = false;
			} else {
				this.brevetValidation.course_id = true;
			}

			if (this.brevet.price == null) {
				success = false;
				this.brevetValidation.price = false;
			} else {
				this.brevetValidation.price = true;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.brevet.id != 0) {
					action = 'put';
					addition = '/' + vm.brevet.id;
				}
				this.$APICall(action, 'brevets' + addition, this.brevet, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.brevet.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.brevet.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.brevet.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.brevet.id != 0) {
			this.$APICall('get', 'brevets/' + this.brevet.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.brevet = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.brevetsRenewal'),
							href: '/#/brevets',
							disabled: false,
						},
						{
							text: vm.brevet.id,
							href: '/#/brevets/' + vm.brevet.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.brevetsRenewal'),
					href: '/#/brevets',
					disabled: false,
				},
				{
					text: this.$t('modules.newBrevetRenewal'),
					href: '/#/brevets/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
		}
	},
};
</script>

<style scoped></style>
